/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actions from './AddressBookEntry-Actions';

const addresBookEntry_init_state = {
    addressBookEntries: [],
    billingAddress: [],
    totalEntries: 0,
    totalPages: 0,
    pageNumber: 0,
    guestAddressBookEntries: [],
};

const addressBookEntryReducer = (state = addresBookEntry_init_state, action) => {
    switch (action.type) {
        case actions.setAddressBookEntry().type:
            return {
                ...state,
                addressBookEntries: action.data?.addressBookEntries,
                totalEntries: action.data?.totalEntries,
                pageNumber: action.data?.pageNumber,
                totalPages: action.data?.totalPages,
            };
        case actions.clearAddressBookEntry().type:
            return {
                ...state,
                addressBookEntries: [],
                guestAddressBookEntries: [],
                totalEntries: 0,
                pageNumber: 0,
                totalPages: 0,
            };
        case actions.setBillingUserAddressBookEntry().type:
            return {
                ...state,
                billingAddress: action.data,
            };
        default:
            return state;
    }
};

export default addressBookEntryReducer;
